import { QUOTE_FORM, QuoteForm, QuoteFormStore, CLEAR_QUOTE_FORM } from './types';
import { TRAVELLER_AGE, TravellerAge } from '../travellers-plan';
import { get, map, set } from 'lodash';
import { RESET_STORE, STORE, TRANSLATE_DATE_FORMAT, WhitelistAction } from '../global';
import { checkWhitelist, formatDateFields, isToTranslateDate } from '../reducer-utils';
import { dayjs } from '@trip-ux/common';

const initialState = {};

export const quoteForm = (
  state: QuoteFormStore = {},
  action: {
    type: string;
    payload?: unknown;
  }
): QuoteFormStore => {
  switch (action.type) {
    case TRAVELLER_AGE: {
      const act = action.payload as TravellerAge;
      const travellers = map(state.form.travellers, tr =>
        tr.referenceNumber === act.paxId ? { ...tr, age: act.age } : tr
      );
      return { ...state, form: { ...state.form, travellers } };
    }
    case QUOTE_FORM: {
      const act = action.payload as QuoteForm;
      return { form: act };
    }
    case CLEAR_QUOTE_FORM:
    case RESET_STORE: {
      const { whitelist } = (action.payload ?? {}) as WhitelistAction;
      return checkWhitelist(whitelist, STORE.QUOTE_FORM, state, initialState);
    }
    case TRANSLATE_DATE_FORMAT: {
      const previousDateFormat = get(action.payload, 'previousDateFormat');
      if (isToTranslateDate(previousDateFormat, state, 'form')) {
        const currentDateFormat = get(action.payload, 'dateFormat');
        return set(state, 'form', formatDates(state.form, previousDateFormat, currentDateFormat));
      } else {
        return state;
      }
    }
    default:
      return state;
  }
};

const formatDates = (form, previousDateFormat, currentDateFormat) => {
  const formattedDateTravellers = form.travellers.map(val => {
    if ('dateOfBirth' in val) {
      val.dateOfBirth = dayjs(val.dateOfBirth, previousDateFormat).format(currentDateFormat);
    }
    if (val?.tripBookingDate) {
      val.tripBookingDate = dayjs(val.tripBookingDate, previousDateFormat).format(currentDateFormat);
    }
    return val;
  });

  const quoteFormDateFields = [
    'departureDate',
    'returnDate',
    'returnDateMultiTrip',
    'arrivingDate',
    'schoolStartDate',
    'schoolEndDate',
    'leavingDate',
    'coverageStartDate',
    'coverageEndDate'
  ];
  const formattedDateFields = formatDateFields(form, quoteFormDateFields, previousDateFormat, currentDateFormat);
  return {
    ...form,
    ...formattedDateFields,
    travellers: formattedDateTravellers
  };
};
